import React from 'react';
import { MVX_REFERENCES } from '../../models/mvxReferences';

/**
 * MVX "References" tab — the citations behind the MVX Plus section. Static list
 * (MVX isn't a Section, so it can't use the DB Reference Library), each with a
 * PubMed / vendor link.
 */
export class MvxReferencesSection extends React.Component {
  render() {
    return (
      <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
        {MVX_REFERENCES.map((r, i) => (
          <li key={i} style={{ marginBottom: 8, fontSize: 12, lineHeight: 1.45 }}>
            {r.citation}{' '}
            <a href={r.url} target="_blank" rel="noopener noreferrer">
              [link]
            </a>
          </li>
        ))}
      </ul>
    );
  }
}

export default MvxReferencesSection;
